import { memo, useCallback, useMemo, useState } from 'react';
import { Box, Grow, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';

import { SaveOutlined, RestartAltRounded } from '@mui/icons-material';

import { useActions } from '../../../../hooks/useActions';

import { ButtonUi } from '../../../UI/Button/Button';
import { TextFieldUi } from '../../../UI/TextField/TextField';
import { sessionNotesStyle } from './style';

export const SessionNotes = memo((props) => {
  const { label, val, className } = props;
  const { t } = useTranslation();

  const { updateSessionNotesById } = useActions();

  const { selectedSession } = useSelector((state) => state.sessions);

  const {
    id: sessionId,
    client_commands,
    created,
    updated,
    duration,
    end_date,
    organization,
    practitioner_commands,
    start_date,
    team,
    therapist,
    ...updateSession
  } = selectedSession;

  const [notes, setNotes] = useState(val);

  const isNotesChanged = notes !== val;

  const { sessionNotes } = sessionNotesStyle;

  const onChangeNotes = useCallback(
    (event) => {
      setNotes((prev) => {
        if (prev === t('undefined_variables.no_data')) {
          return event.target.value.slice(-1);
        }
        return event.target.value;
      });
    },
    [t],
  );

  const resetNotes = useCallback(() => {
    setNotes(val);
  }, [val]);

  const onUpdateNotes = useCallback(() => {
    const updateBody = {
      ...updateSession,
      attributes: { ...updateSession?.attributes, notes: [notes] },
    };
    updateSessionNotesById(sessionId, updateBody);
  }, [notes, sessionId, updateSession, updateSessionNotesById]);

  return (
    <Box
      sx={sessionNotes}
      className={`row row-detail align-items-left ${className}`}
    >
      <Box className='card-header'>
        <Typography className='label' variant='h6'>
          {label}
        </Typography>
        <Grow in={isNotesChanged}>
          <Box className='notes-actions'>
            <ButtonUi
              disabled={!notes}
              isIconBtn
              tooltipTitle={t('buttons.save')}
              tooltipPlacement='top'
              className='save-btn'
              size='small'
              onClickHandler={onUpdateNotes}
            >
              <SaveOutlined />
            </ButtonUi>
            <ButtonUi
              isIconBtn
              tooltipTitle={t('buttons.reset')}
              tooltipPlacement='top'
              size='small'
              className='reset'
              onClickHandler={resetNotes}
            >
              <RestartAltRounded />
            </ButtonUi>
          </Box>
        </Grow>
      </Box>
      <TextFieldUi
        className='simple-text-field'
        label=''
        multiline
        autoFocus={false}
        name='notes'
        fullWidth
        required
        value={notes}
        maxRows={4}
        handleChange={onChangeNotes}
      />
    </Box>
  );
});
